document.addEventListener('alpine:init', () => {
  async function cartSection(response, section) {
    const bundled = response?.sections?.[section];
    if (typeof bundled === 'string' && bundled.trim()) return bundled;
    try {
      const url = new URL(theme.routes.cart_url, window.location.origin);
      url.searchParams.set('sections', section);
      const result = await fetch(url.href, { credentials: 'same-origin', cache: 'no-store' });
      if (!result.ok) throw new Error('Cart section refresh failed');
      const sections = await result.json();
      if (typeof sections[section] !== 'string' || !sections[section].trim()) throw new Error('Cart section unavailable');
      return sections[section];
    } catch (error) {
      const notice = document.getElementById('cart-errors');
      if (notice) notice.textContent = theme.strings.cartError;
      console.warn('Unable to refresh cart section:', section);
      return null;
    }
  }

  Alpine.data('ThemeModule_CartItems', (context) => {
    return {
      context: context,
      itemsRoot: null,
      locked: null,
      items_section: '',
      sections: '',
      _updateVersion: 0,
      async _refreshItems(response) {
        const version = ++this._updateVersion;
        const html = await cartSection(response, this.items_section);
        if (!html || version !== this._updateVersion || !this.itemsRoot?.isConnected) return false;
        const items = querySelectorInHTMLString('[data-cart-items]', html);
        if (!items) return false;
        Alpine.morph(this.itemsRoot, items.outerHTML);
        return true;
      },
      init() {
        if (context === 'drawer') {
          this.items_section = 'drawer-cart-items';
          this.sections =
            'drawer-cart-items,drawer-cart-footer,cart-item-count,cart-live-region';
        } else {
          this.items_section = 'cart-items';
          this.sections =
            'cart-items,cart-footer,cart-item-count,cart-live-region';
        }

        this.itemsRoot = this.$root;

        window.addEventListener('switch:cart:afteradditem', async (e) => {
          if (!await this._refreshItems(e.detail?.response)) return;
          this.$nextTick(() => {
            document.body.dispatchEvent(new CustomEvent('switch:load:images', { bubbles: true }));
          });
        });

        window.addEventListener('switch:modalcart:cartqtychange', async (e) => {
          if (!this.itemsRoot?.contains(e.detail?.originalTarget)) return;

          if (!await this._refreshItems(e.detail?.response)) return;

          this.$nextTick(() => {
            document.body.dispatchEvent(new CustomEvent('switch:load:images', { bubbles: true }));
            this.itemsRoot.querySelectorAll('input').forEach((inputEl) => {
              inputEl.value = inputEl.getAttribute('value');
            });
          });

          const statusHTML = e.detail?.response?.sections?.['cart-live-region'];
          const cartStatus = document.getElementById('cart-live-region-text');
          const statusNode = typeof statusHTML === 'string' ? parseDOMFromString(statusHTML).firstElementChild : null;
          if (cartStatus && statusNode) {
            cartStatus.textContent = statusNode.textContent;
            cartStatus.setAttribute('aria-hidden', false);
            setTimeout(() => cartStatus.setAttribute('aria-hidden', true), 1000);
          }

          if (e.detail.originalTarget) {
            this.$nextTick(() => {
              if (!this.itemsRoot.contains(e.detail.originalTarget)) {
                let focusRoot;

                if (this.itemsRoot.closest('[role="dialog"]')) {
                  focusRoot =
                    this.itemsRoot.closest('[role="dialog"]').parentNode;
                } else {
                  focusRoot = this.itemsRoot;
                }

                this.$focus.within(focusRoot).first();
              }
            });
          }
        });
      },
      itemQuantityChange(key, value) {
        if (this.locked) return;

        const lineItemEl = this.$el.closest('li[data-cart-item-key]');
        const id = key ? key : lineItemEl.getAttribute('data-cart-item-key'),
          quantity = parseInt(!isNaN(value) ? value : this.$el.value, 10);

        const config = fetchConfigDefaults();

        let sections = this.sections;

        config.headers.Accept = 'application/javascript';

        config.body = JSON.stringify({
          id,
          quantity,
          sections,
          sections_url: window.location.pathname,
        });

        const lastValue = parseInt(this.$el.dataset.lastValue, 10);

        if (quantity !== lastValue) {
          lineItemEl.classList.add('opacity-50', 'cursor-progress');

          const currentCount = Alpine.raw(Alpine.store('cart_count').count);

          this.locked = lineItemEl;

          fetch(theme.routes.cart_change_url, config)
            .then(async (res) => {
              const data = await res.json();
              if (!res.ok && !data.status) data.status = res.status;
              return data;
            })
            .then((data) => {
              if (data.status) {
                const errorEl = lineItemEl.querySelector(
                  '[data-cart-quantity-error]'
                );

                if (errorEl) errorEl.textContent = data.description || data.message || theme.strings.cartError;

                if (errorEl) errorEl.classList.remove('hidden');

                lineItemEl.classList.remove('opacity-50', 'cursor-progress');

                this.$el.value = lastValue;
                this.$el.dispatchEvent(new Event('input'));
              } else {
                document.body.dispatchEvent(
                  new CustomEvent('switch:modalcart:cartqtychange', {
                    bubbles: true,
                    detail: { response: data, originalTarget: lineItemEl },
                  })
                );
              }
            })
            .catch(() => {
              const notice = document.getElementById('cart-errors');
              if (notice) notice.textContent = theme.strings.cartError;
              this.$el.value = lastValue;
              this.$el.dispatchEvent(new Event('input'));
            })
            .finally(() => {
              lineItemEl.classList.remove('opacity-50', 'cursor-progress');
              this.locked = null;
            });
        }
      },
      removeItem(key) {
        this.itemQuantityChange(key, 0);
      },
      _adjustQty(el, operation) {
        const inputEl = el
          .closest('li[key]')
          .querySelector('input[type="number"]');

        const lastValue = parseInt(inputEl.dataset.lastValue, 10);

        let newValue;

        if (operation == 'increment') {
          newValue = lastValue + 1;
        }

        if (operation == 'decrement') {
          if (lastValue > 0) {
            newValue = lastValue - 1;
          } else {
            newValue = 0;
          }
        }

        if (operation == 'remove') {
          newValue = 0;
        }

        inputEl.value = newValue;

        // this.$nextTick(() => {
        inputEl.dispatchEvent(new Event('change', { bubbles: true }));
        // });
      },
      increment() {
        this._adjustQty(this.$el, 'increment');
      },
      decrement() {
        this._adjustQty(this.$el, 'decrement');
      },
      remove() {
        this._adjustQty(this.$el, 'remove');
      },
    };
  });
});
